module.exports = __webpack_public_path__ + "img/Glucose GOD POD.2(mid).890e37aa.jpg";